<div class="content-container container">
  <div class="login-error-content">
    <h1 rtI18n>We couldn't sign you in</h1>
    <p class="login-error-message">{{message}}</p>
    <div class="login-error-buttons">
      @if (isProfileNotFound) {
        <button type="button" class="btn btn-secondary" (click)="clickCleanRestart()" [disabled]="retryClicked">{{retryClicked ? 'Redirecting...' : 'Try a different sign-in'}}</button>
      } @else {
        <button type="button" class="btn btn-secondary" (click)="clickRetry()" [disabled]="retryClicked">{{retryClicked ? 'Redirecting...' : 'Back to sign in'}}</button>
      }
    </div>
  </div>
</div>
